package com.trevorwiebe.timesheet.loads.domain.usecases

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.loads.domain.LoadsRepository
import com.trevorwiebe.timesheet.loads.domain.model.Load

/**
 * Sets a load's dispatch assignment: which employee it belongs to ([employeeId], empty = unassigned)
 * and whether that assignment is [dispatchConfirmed]. The load already carries its fully-resolved
 * stops, so this just rewrites the document with the changed fields.
 */
class UpdateLoadAssignment(
    private val loadsRepository: LoadsRepository,
) {
    suspend fun invoke(load: Load, employeeId: String, dispatchConfirmed: Boolean): TSResult =
        loadsRepository.updateLoad(
            load.copy(employeeId = employeeId, dispatchConfirmed = dispatchConfirmed)
        )
}
